import Image from '@components/image'
import { StyleCard, StyleCardHeader, StyleTimeCard } from './style'
import Circle from '@components/circle'
import Svg from '@components/svg'
import { FC } from 'react'
import Typography from '@components/typography'
import { formatDistanceToNow } from 'date-fns'
interface InstantAppointmentQueueCardProps {
  appointment: any
}
const InstantAppointmentQueueCard: FC<InstantAppointmentQueueCardProps> = ({
  appointment,
}) => {
  return (
    <StyleCard>
      <StyleCardHeader>
        <Image
          src={`${process.env.BUCKET_URL}/${appointment?.patient?.avatar}`}
          fallbackType="user"
        />
        <Circle size={25} bg="primary600">
          <Svg svg="cross" size={14} color={'text'} />
        </Circle>
      </StyleCardHeader>
      <Typography content={appointment?.patient?.name} tc="text" />
      <StyleTimeCard>
        <Svg svg="time" size={16} color={'primary'} />
        <Typography
          size={12}
          tc="primary"
          content={`Added: ${formatDistanceToNow(
            new Date(appointment?.infos?.addedOnQueue),
            {
              addSuffix: true,
            },
          )
            .replace(/^about /, '')
            .replace('less than', '')}`}
        />
      </StyleTimeCard>
    </StyleCard>
  )
}

export default InstantAppointmentQueueCard
